import { Checkbox, Field } from '@workwhile/ui'
import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { FiltersSchema } from '../../filtersSchema'
import { shiftStatuses } from './constants'

export const StatusesFilter = () => {
  const { setValue, watch } = useFormContext<FiltersSchema>()

  const shiftStatusesValue = watch('shift.statuses') ?? []

  const selectableColumnsCheckboxes = useMemo(() => {
    return shiftStatuses.map(({ id, label }) => {
      const isSelected = shiftStatusesValue.includes(id)
      return (
        <Field key={`statues-filter-${id}`}>
          <Checkbox
            value={isSelected}
            onChange={(checked) => {
              if (!checked) {
                setValue(
                  'shift.statuses',
                  shiftStatusesValue.filter((status) => status !== id)
                )
              } else {
                setValue('shift.statuses', [...shiftStatusesValue, id])
              }
            }}
          >
            <span>{label}</span>
          </Checkbox>
        </Field>
      )
    })
  }, [shiftStatusesValue])

  return selectableColumnsCheckboxes
}
